import { Action } from '@ngrx/store';
import {
  Profile,
  UpdateProfile$Request,
  UpdateProfileWeight$Request,
  UpdateProfileExerciseLevel$Request,
  GetProfile$Response
} from '@api/service';

export const GET_OWNER = '[Profile] Get owner';
export const GET_OWNER_FAIL = '[Profile] Get owner Fail';
export const GET_OWNER_SUCCESS = '[Profile] Get owner Success';

export const UPDATE_OWNER = '[Profile] Update owner';
export const UPDATE_OWNER_FAIL = '[Profile] Update owner Fail';
export const UPDATE_OWNER_SUCCESS = '[Profile] Update owner Success';

export const UPDATE_OWNER_WEIGHT = '[Profile] Update owner weight';
export const UPDATE_OWNER_WEIGHT_FAIL = '[Profile] Update owner weight Fail';
export const UPDATE_OWNER_WEIGHT_SUCCESS = '[Profile] Update owner weight Success';

export const UPDATE_OWNER_EXERCISE = '[Profile] Update owner Exercise';
export const UPDATE_OWNER_EXERCISE_FAIL = '[Profile] Update owner Exercise Fail';
export const UPDATE_OWNER_EXERCISE_SUCCESS = '[Profile] Update owner Exercise Success';

export class GetOwner implements Action {
  readonly type = GET_OWNER;
}

export class GetOwnerFail implements Action {
  readonly type = GET_OWNER_FAIL;
  constructor(public payload: any) {}
}

export class GetOwnerSuccess implements Action {
  readonly type = GET_OWNER_SUCCESS;
  constructor(public payload: GetProfile$Response) {}
}

export class UpdateOwner implements Action {
  readonly type = UPDATE_OWNER;
  constructor(public payload: { profile: UpdateProfile$Request; msg: string }) {}
}

export class UpdateOwnerFail implements Action {
  readonly type = UPDATE_OWNER_FAIL;
  constructor(public payload: any) {}
}

export class UpdateOwnerSuccess implements Action {
  readonly type = UPDATE_OWNER_SUCCESS;
  constructor(public payload: Profile) {}
}

export class UpdateOwnerWeight implements Action {
  readonly type = UPDATE_OWNER_WEIGHT;
  constructor(public payload: { profile: UpdateProfileWeight$Request; msg: string }) {}
}

export class UpdateOwnerWeightFail implements Action {
  readonly type = UPDATE_OWNER_WEIGHT_FAIL;
  constructor(public payload: any) {}
}

export class UpdateOwnerWeightSuccess implements Action {
  readonly type = UPDATE_OWNER_WEIGHT_SUCCESS;
  constructor(public payload: Profile) {}
}

export class UpdateOwnerExercise implements Action {
  readonly type = UPDATE_OWNER_EXERCISE;
  constructor(public payload: { profile: UpdateProfileExerciseLevel$Request; msg: string }) {}
}

export class UpdateOwnerExerciseFail implements Action {
  readonly type = UPDATE_OWNER_EXERCISE_FAIL;
  constructor(public payload: any) {}
}

export class UpdateOwnerExerciseSuccess implements Action {
  readonly type = UPDATE_OWNER_EXERCISE_SUCCESS;
  constructor(public payload: Profile) {}
}

export type ProfileAction =
  | GetOwner
  | GetOwnerFail
  | GetOwnerSuccess
  | UpdateOwner
  | UpdateOwnerFail
  | UpdateOwnerSuccess
  | UpdateOwnerWeight
  | UpdateOwnerWeightFail
  | UpdateOwnerWeightSuccess
  | UpdateOwnerExercise
  | UpdateOwnerExerciseFail
  | UpdateOwnerExerciseSuccess;
